import { httpClient } from '@/api/httpClient';
import {
  mapApiResourceToProgressComparisonEntry,
  mapApiResourceToProgressEntry,
  mapApiResourceToProgressMetricSeries,
  mapProgressEntryWriteDraftToApiPayload,
} from './progressMapping';
import type {
  ProgressComparisonEntry,
  ProgressComparisonEntryApiResource,
  ProgressEntry,
  ProgressEntryApiResource,
  ProgressEntryWriteDraft,
  ProgressMetricSeries,
  ProgressMetricSeriesApiResource,
} from './progressApi.types';

export async function fetchPatientProgressSeries(
  patientId: string
): Promise<ProgressMetricSeries[]> {
  const response = await httpClient.get<ProgressMetricSeriesApiResource[]>(
    '/patients/' + patientId + '/progress-series'
  );
  return response.data.map(mapApiResourceToProgressMetricSeries);
}

export async function fetchPatientProgressComparison(
  patientId: string
): Promise<ProgressComparisonEntry[]> {
  const response = await httpClient.get<ProgressComparisonEntryApiResource[]>(
    '/patients/' + patientId + '/progress-comparison'
  );
  return response.data.map(mapApiResourceToProgressComparisonEntry);
}

export async function fetchOwnPetProgressSeries(
  patientId: string
): Promise<ProgressMetricSeries[]> {
  const response = await httpClient.get<ProgressMetricSeriesApiResource[]>(
    '/me/pets/' + patientId + '/progress-series'
  );
  return response.data.map(mapApiResourceToProgressMetricSeries);
}

export async function fetchOwnPetProgressComparison(
  patientId: string
): Promise<ProgressComparisonEntry[]> {
  const response = await httpClient.get<ProgressComparisonEntryApiResource[]>(
    '/me/pets/' + patientId + '/progress-comparison'
  );
  return response.data.map(mapApiResourceToProgressComparisonEntry);
}

export async function recordProgressEntries(
  patientId: string,
  draft: ProgressEntryWriteDraft
): Promise<ProgressEntry[]> {
  const response = await httpClient.post<ProgressEntryApiResource[]>(
    '/patients/' + patientId + '/progress-entries',
    mapProgressEntryWriteDraftToApiPayload(draft)
  );
  return response.data.map(mapApiResourceToProgressEntry);
}

export async function deleteProgressEntry(entryId: string): Promise<void> {
  await httpClient.delete('/progress-entries/' + entryId);
}
